import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconTextTry = createSVG({
    width: 48,
    children: (jsx("path", { d: "M36.415 6h2.675l-4.115 7.32V18h-2.349v-4.68L28.53 6h2.674l2.606 5.006zM25.644 18h2.554l-2.657-4.525c1.371-.635 2.314-1.99 2.314-3.498a3.984 3.984 0 0 0-3.995-3.978h-4.8v12.002h2.366v-4.167h1.8zm-4.218-9.79h2.435c.891 0 1.628.772 1.628 1.767s-.737 1.783-1.629 1.783h-2.434zM8.91 6h8.829v2.262h-3.24v9.739h-2.367V8.262H8.91z" })),
});

export { IconTextTry };
